<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_personal-asset-account.text1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-account.text2') }}<br />
					{{ $t('rtr_personal-asset-account.text3') }}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<div class="bottom_area">
			<div class="catch_box mb_16 tal">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_personal-asset-account.text4') }}<br />
					{{ $t('rtr_personal-asset-account.text5') }}
				</p>
				<p class="body_m fc_white">
					{{ $t('rtr_personal-asset-account.text6') }}<br />
					{{ $t('rtr_personal-asset-account.text7') }}<br />
					{{ $t('rtr_personal-asset-account.text8') }}
				</p>
			</div>
			<div class="bottom_box">
				<div class="position_box">
					<div class="title_m mb_16">
						{{ $t('rtr_personal-asset-account.text9') }}
					</div>
					<div class="body_m">
						{{ $t('rtr_personal-asset-account.text10') }}<br />
						{{ $t('rtr_personal-asset-account.text11') }}
					</div>
				</div>
			</div>
			<div class="catch_box mt_16 mb_16">
				<p class="title_l fc_white">
					{{ $t('rtr_personal-asset-account.text12') }}<br />
					{{ $t('rtr_personal-asset-account.text13') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Account.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
